import React from 'react';
import styles from './BoardShareButton.less';
import classNames from 'classnames';
import { forTemplate } from '@trello/i18n';
import { useBoardBackground } from 'app/src/components/Theme';
import { AddMemberIcon, GlyphProps } from '@trello/nachos/icons/add-member';
import { BoardHeaderTestIds } from '@trello/test-ids';

const format = forTemplate('board_share_button');

interface BoardShareButtonProps {
  onClickButton: () => void;
}

export const BoardShareButton: React.FC<BoardShareButtonProps> = ({
  onClickButton,
}) => {
  const { backgroundBrightness } = useBoardBackground();
  const isLightTheme = backgroundBrightness === 'light';
  const iconProps: GlyphProps = {
    size: 'small',
  };
  if (isLightTheme) iconProps.color = 'light'; // otherwise default icon color (unset)

  return (
    <button
      title={format('share-board')}
      className={classNames(
        styles.boardShareButton,
        isLightTheme && styles.lightBackground,
      )}
      data-test-id={BoardHeaderTestIds.BoardShareButton}
      onClick={onClickButton}
    >
      <AddMemberIcon
        dangerous_className={styles.boardShareButtonIcon} // needed for print color styles
        {...iconProps}
      />
      <span className={styles.boardShareButtonText}>{format('share')}</span>
    </button>
  );
};
